// removed by extract-text-webpack-plugin
module.exports = {"formWrapper":"SearchBar__formWrapper___1QMp4","searchInput":"SearchBar__searchInput___pfBNH","searchButton":"SearchBar__searchButton___2a8MQ","errorText":"SearchBar__errorText___wHqis"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/SearchBar.css
// module id = 1221
// module chunks = 0